<div class="dashboard wrapper--spacing-horizontal">
  <div class="flex--row flex--justify-space-between spacing--margin-bottom spacing--padding-bottom">
    <app-today></app-today>
  </div>

  <app-recent-deliveries></app-recent-deliveries>
  <app-recent-invoices></app-recent-invoices>
</div>
